export const ONBOARDING_ATTENDEE_PREFERENCE_VALUE = 'seen';
